import {useForm} from 'react-hook-form';
import {CrupdateRateSheetLayout} from './crupdate-rate-sheet-layout';
import {Trans} from '@common/i18n/trans';
import { useEffect, useState } from 'react';
import { ProgressCircle } from '@common/ui/progress/progress-circle';
import { RateSheetSettingsWithValues, useUpdateRateSheetSettings } from '@app_modules/requests/update-rate-sheet-settings';
import { CrupdateRateSheetForm } from './crupdate-rate-sheet-form';
import { slugifyString } from '@common/utils/string/slugify-string';

export function CreateRateSheetPage({id, items, marketRateDate, timeChange}: any) {
  if (items.length) {
    return (
      <>
      <RateSheetUploading id={id} market_rate_date={marketRateDate} data_items={items} timeChange={timeChange}/>
      </>
    );
  } else {
    return (<ProgressCircle isIndeterminate aria-label="Loading settings..." />);
  }
}

export function RateSheetUploading({id, market_rate_date, data_items, timeChange}:{id: number, market_rate_date: string, data_items: any, timeChange: any}) {

  const [defaultValues, setDefaultValues] = useState<any>({});
  

  const form = useForm<RateSheetSettingsWithValues>({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (data_items) {
      const newDefaultValues: { [key: string]: string } = {};
      data_items.forEach((item: any, pindex: number) => {
        newDefaultValues[`${pindex}_investor_code`] = item.investor_code;

        if (item.subItems && item.subItems.length > 0) {
          item.subItems.forEach((subItem: any, index: number) => {
            item.subItems.forEach((subItem: any, index: number) => {
              newDefaultValues[`${pindex}_${index}_loan_program_type`] = subItem.loan_program_type;
            });
          });
        }
      });
      // Update state and reset form with new values
      setDefaultValues(newDefaultValues);
      form.reset(newDefaultValues); // Reset form with updated values
    }
  }, [data_items, timeChange, form]);

  return (
    <CrupdateRateSheetLayout
      form={form}
    >
      <CrupdateRateSheetForm id={id} market_rate_date={market_rate_date} data_items={data_items} timeChange={timeChange}/>
    </CrupdateRateSheetLayout>
  );
  
}


  
